import { useRouter } from "next/router"
import { BlitzPage } from "@blitzjs/next"
import { LoginForm } from "app/auth/components/LoginForm"
import Authentication from "app/core/layouts/OnboardingV2"

const LoginPage: BlitzPage = () => {
  const router = useRouter()

  return (
    <div>
      <LoginForm
        onSuccess={({ selectOrganization, user }) => {
          if (router.query.client_id) {
            const queryProps = router.query as any

            // It's an OAuth client, so we need to redirect back to
            // to the /oauth/authorize endpoint
            router.push(
              "/oauth/authorize?" +
                new URLSearchParams({
                  ...queryProps,
                })
            )
            return
          }

          const next = router.query.next ? decodeURIComponent(router.query.next as string) : "/"
          if (selectOrganization && !router.query.bypassSelectOrganization) {
            router.push("/select-organization")
            return
          }
          router.push(next)
        }}
      />
    </div>
  )
}

LoginPage.redirectAuthenticatedTo = "/dashboard"
LoginPage.getLayout = (page) => <Authentication title="Log In | Superwall">{page}</Authentication>

export default LoginPage
